import type { Selection } from '@/shared/lib/forest'
import type { TreeNodeType } from '@/shared/lib/tree'
import type { PickerForest, PickerNodeData } from './picker-forest'

const legacyId = (data: PickerNodeData) =>
	data.kind === 'pg' ? data.pgId : `${data.pgId}|${data.categoryId}`

const treeCache = new WeakMap<PickerForest, TreeNodeType[]>()

/**
 * @deprecated Read-only consumers only (tree chart, OG list filters). Builds
 * the nested `TreeNodeType[]` shape once per forest instance.
 */
export const toLegacyTree = (pickerForest: PickerForest): TreeNodeType[] => {
	const cached = treeCache.get(pickerForest)
	if (cached) return cached

	const nodes = new Map<string, TreeNodeType>()
	for (const id of pickerForest.ids) {
		const data = pickerForest.dataOf.get(id)!
		const parentId = pickerForest.parentOf.get(id) ?? null
		const parent = parentId === null ? undefined : nodes.get(parentId)
		const node: TreeNodeType = {
			id: legacyId(data),
			name: data.name,
			level: (pickerForest.depthOf.get(id) ?? 0) + 1,
			visible: true,
			parent,
			children: [],
		}
		nodes.set(id, node)
		if (parent) parent.children.push(node)
	}
	const tree = pickerForest.roots.map((id) => nodes.get(id)!)
	treeCache.set(pickerForest, tree)

	return tree
}

/**
 * @deprecated Read-only consumers only. Leaf ids in the legacy `${pgId}|${catId}`
 * format for everything the selection covers. A PG with no categories yields
 * its own id.
 */
export const toLegacyLeafIds = (
	pickerForest: PickerForest,
	selection: Selection
): string[] => {
	const output: string[] = []
	for (const root of selection.roots) {
		for (const leaf of pickerForest.leaves(root)) {
			output.push(legacyId(pickerForest.dataOf.get(leaf)!))
		}
	}

	return output
}
